import script from "./MultiBooking.vue?vue&type=script&setup=true&lang=js"
export * from "./MultiBooking.vue?vue&type=script&setup=true&lang=js"

import "./MultiBooking.vue?vue&type=style&index=0&id=bb36177e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bb36177e"]])

export default __exports__